import { Deserializable } from '../protocols/deserializable';
import { SpousalWaiverTypeEnum } from './spousal-waiver-type.enum';

export class SpousalWaiverType implements Deserializable {
  public id!: SpousalWaiverTypeEnum;
  public name!: string;

  onDeserialize() {}
}
